import { defineStore } from 'pinia';
import notificationWrapper from '@/utils/helpers/notificationWrapper';
import { useProjectStore } from './projectStore';

export const useInvoiceStore = defineStore('invoice', {
  state: () => ({
    invoices: [],
    invoicesLoading: false,
  }),

  actions: {
    async getInvoices() {
      this.invoicesLoading = true;
      try {
        const projectStore = useProjectStore();
        const invoices = await window.appConnector.getInvoices(projectStore.projectIdSelected);
        this.invoices = invoices;
        this.invoicesLoading = false;
      } catch (error) {
        this.invoicesLoading = false;
        if (error?.status === 404) {
          return;
        }
        notificationWrapper();
        throw error;
      }
    },
    async handleDownload(invoiceId: string) {
      try {
        const projectStore = useProjectStore();
        const response = await window.appConnector.getInvoiceDownload(projectStore.projectIdSelected, invoiceId);
        return response.data;
      } catch (error) {
        notificationWrapper();
        throw error;
      }
    },
  },
});
